import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=b80e50d4&scoped=true&"
import script from "./NotificationSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=b80e50d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80e50d4",
  null
  
)

export default component.exports